import React from 'react';

import { NodeProps } from './shared';

export function OrderedListNode({ children }: NodeProps) {
  return (
    <ol className="[&_li::marker]:text-inherit list-outside list-decimal ps-[40px]">
      {children}
    </ol>
  );
}
